// extracted by mini-css-extract-plugin
export default {"container":"DownloadBlock_container__RfgZt","image":"DownloadBlock_image__qQTeq"};